import { COLUMN_DEFINITIONS_MAP } from "./columnDefs";
import { getTableData } from "./utils";
import type {
  GetHeadToHeadPlayerGameLogQuery,
  GetHeadToHeadPlayerGameStatsQuery,
} from "@/graphql/gql/graphql";

const usePlayerLogAndStatsTable = (
  gameLogData: GetHeadToHeadPlayerGameLogQuery["event"],
  gameStatsData: GetHeadToHeadPlayerGameStatsQuery["player"]
) => {
  const tableData = getTableData(gameLogData, gameStatsData);

  return { tableData, columns: COLUMN_DEFINITIONS_MAP };
};

export default usePlayerLogAndStatsTable;
